(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9921],{

/***/ 7153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PZ": function() { return /* binding */ CloseButton; },
/* harmony export */   "X6": function() { return /* binding */ Pane; },
/* harmony export */   "aV": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5420);
/* harmony import */ var _wds_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9224);




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles$1 = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (_a) {
    var spacing = _a.spacing, type = _a.type;
    return ({
        wrenchCloseButton: function (_a) {
            var component = _a.component, disabled = _a.disabled;
            var componentSpecificStyles = {
                badge: {
                    position: 'relative',
                    top: 'none',
                    right: 'none',
                    padding: 0,
                    marginLeft: spacing[3],
                },
                banner: {
                    position: 'absolute',
                    top: spacing[2],
                    right: spacing[2],
                    padding: 0,
                },
                alert: {
                    padding: [spacing[2], 0, spacing[2], spacing[5]],
                    textAlign: 'right',
                },
                default: {
                    position: 'absolute',
                    right: spacing[1],
                    top: spacing[1],
                    padding: spacing[2],
                },
            };
            return __assign(__assign({}, componentSpecificStyles[component !== null && component !== void 0 ? component : 'default']), { fontSize: type.fontSize.body, display: 'inline-flex', justifyContent: 'center', alignItems: 'center', cursor: !disabled && 'pointer', borderRadius: '0', textDecoration: 'none', background: 'transparent', border: 'none', '&:hover': {
                    transition: 'none',
                    textDecoration: 'none',
                }, '&:active': {
                    transition: 'none',
                    outline: 'none',
                } });
        },
    });
});

var CloseButton = function (_a) {
    _a.children; var component = _a.component, label = _a.label, _c = _a.variant, variant = _c === void 0 ? "light" : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, rest = __rest(_a, ["children", "component", "label", "variant", "disabled"]);
    var wrenchCloseButton = useStyles$1({ component: component, disabled: disabled }).wrenchCloseButton;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("button", __assign({ type: "button", className: wrenchCloseButton, "aria-label": label, disabled: disabled }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .safeRest */ .Q6)(rest)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_wds_icons__WEBPACK_IMPORTED_MODULE_2__/* .IconX */ .kLi, { title: "close", color: variant })));
};

/* eslint-disable jsx-a11y/no-static-element-interactions */
var Overlay = function (_a) {
    var className = _a.className, onClick = _a.onClick;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: className, onClick: onClick, "data-testid": "Overlay__WDS" });
};

var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (_a) {
    var palette = _a.palette, spacing = _a.spacing, theme = __rest(_a, ["palette", "spacing"]);
    var pane = {
        bgColor: palette.background.accent,
        padding: spacing[5],
    };
    return {
        wrenchPane: function (_a) {
            var hide = _a.hide, transparent = _a.transparent;
            return (__assign(__assign(__assign({}, (hide && _wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .visuallyHidden */ .jy)), (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .defaultFonts */ .FZ)(theme)), { background: transparent ? 'none' : pane.bgColor }));
        },
        wrenchPaneBody: function () { return ({
            padding: pane.padding,
        }); },
    };
});

var Pane = function (_a) {
    var children = _a.children, _b = _a.hide, hide = _b === void 0 ? false : _b, id = _a.id, _c = _a.padding, padding = _c === void 0 ? false : _c, labelledBy = _a.labelledBy, role = _a.role, _d = _a.transparent, transparent = _d === void 0 ? false : _d, rest = __rest(_a, ["children", "hide", "id", "padding", "labelledBy", "role", "transparent"]);
    var _e = useStyles({
        hide: hide,
        transparent: transparent,
    }), wrenchPane = _e.wrenchPane, wrenchPaneBody = _e.wrenchPaneBody;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ className: wrenchPane, role: role, id: id, "aria-labelledby": labelledBy, "aria-hidden": hide }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .safeRest */ .Q6)(rest)), padding ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchPaneBody }, children) : children));
};




/***/ }),

/***/ 2304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* unused harmony export MODAL_SIZES */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _wds_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4661);
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5420);
/* harmony import */ var _wds_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4779);
/* harmony import */ var _wds_internal_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7153);






/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var useStyles$3 = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .createMemoStyles */ .Im)(function (theme) {
    var spacing = theme.spacing;
    return {
        wrenchModalBody: function (_a) {
            var padding = _a.padding;
            return (__assign({ overflowY: 'auto', flexGrow: 1 }, (padding && {
                padding: [spacing[4], spacing[6], spacing[6], spacing[6]],
            })));
        },
    };
});

var ModalBody = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_a, ref) {
    _a.className; var children = _a.children, handleClick = _a.handleClick, id = _a.id, padding = _a.padding, rest = __rest(_a, ["className", "children", "handleClick", "id", "padding"]);
    var wrenchModalBody = useStyles$3({
        padding: padding,
    }).wrenchModalBody;
    var handleKeyDown = function (e) {
        if (e.key === _wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .KEYS.ESC */ .tW.ESC) {
            handleClick === null || handleClick === void 0 ? void 0 : handleClick(e);
            e.preventDefault();
        }
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", __assign({ 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0, ref: ref, id: id, className: wrenchModalBody, onKeyDown: handleKeyDown }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .safeRest */ .Q6)(rest)), children));
});
ModalBody.displayName = 'ModalBody';
ModalBody.defaultProps = {
    className: undefined,
    handleClick: undefined,
    id: undefined,
    padding: true,
};

var useStyles$2 = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .createMemoStyles */ .Im)(function (theme) {
    var palette = theme.palette, spacing = theme.spacing;
    return {
        wrenchModalFooter: {
            display: 'flex',
            justifyContent: 'space-between',
            flexShrink: 0,
            padding: spacing[6],
            background: palette.background.light,
            borderTop: "1px solid ".concat(palette.background.accent),
            color: palette.text.dark,
        },
        wrenchModalActions: function (_a) {
            var align = _a.align;
            return (__assign(__assign(__assign({ display: 'flex', flexGrow: 1, flexWrap: 'wrap' }, (align === 'right' && {
                justifyContent: 'flex-end',
            })), (align === 'left' && {
                justifyContent: 'flex-start',
            })), { '&:not([class^="wrenchButtonGroup"])': {
                    '& > button, & > a': {
                        marginLeft: spacing[2],
                    }
                } }));
        },
    };
});

var ModalFooter = function (_a) {
    var align = _a.align, children = _a.children;
    var _b = useStyles$2({
        align: align,
    }), wrenchModalActions = _b.wrenchModalActions, wrenchModalFooter = _b.wrenchModalFooter;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("footer", { className: wrenchModalFooter },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchModalActions }, children)));
};
ModalFooter.defaultProps = {
    align: 'left',
};

var useStyles$1 = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .createMemoStyles */ .Im)(function (theme) {
    var palette = theme.palette, spacing = theme.spacing, _a = theme.type, fontWeight = _a.fontWeight, fontSize = _a.fontSize;
    return {
        wrenchModalHeader: function (_a) {
            var stretched = _a.stretched;
            return ({
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                padding: [spacing[6], spacing[6], spacing[2], spacing[6]],
                background: palette.background.light,
                flexShrink: 0,
                flexDirection: stretched ? 'column' : 'row',
            });
        },
        wrenchModalText: {
            fontSize: 24,
            fontWeight: fontWeight.medium,
            color: palette.text.dark,
            marginTop: 0,
            marginBottom: spacing[2],
        },
        wrenchModalTitle: {
            flexGrow: 1,
            width: '100%',
        },
        wrenchModalSubText: {
            fontSize: fontSize.bodySm,
            fontWeight: fontWeight.regular,
            color: palette.text.dark,
            margin: [spacing[1], 0, 0],
        },
        wrenchModalAddOn: {
            flexGrow: 1,
            marginTop: spacing[3],
            width: '100%',
            minWidth: '33%',
            textAlign: 'right',
            // In the case that an addon is the first child (modal title was omitted)
            // we do not want a margin top
            '& :first-child': {
                marginTop: 0,
            },
        },
    };
});

var ModalHeader = function (_a) {
    var addOn = _a.addOn, header = _a.header, id = _a.id, subHeader = _a.subHeader, stretched = _a.stretched;
    if (subHeader && addOn) {
        throw new Error('You cannot have both subHeader and addon');
    }
    else if (!header && subHeader) {
        throw new Error('You must provide a header if you provide a subHeader');
    }
    var _b = useStyles$1({
        stretched: stretched,
    }), wrenchModalAddOn = _b.wrenchModalAddOn, wrenchModalHeader = _b.wrenchModalHeader, wrenchModalSubText = _b.wrenchModalSubText, wrenchModalText = _b.wrenchModalText, wrenchModalTitle = _b.wrenchModalTitle;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", { className: wrenchModalHeader },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchModalTitle },
            header && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("h2", { className: wrenchModalText, id: id }, header)),
            subHeader && react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: wrenchModalSubText }, subHeader)),
        addOn && react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchModalAddOn }, addOn)));
};
ModalHeader.defaultProps = {
    addOn: undefined,
    header: undefined,
    id: undefined,
    stretched: false,
    subHeader: undefined,
};

var modalWidth = {
    sm: '443px',
    md: '676px',
    lg: '909px',
    xl: '1300px',
    full: '100%',
};
var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .createMemoStyles */ .Im)(function (theme) {
    var _a;
    var breakpoints = theme.breakpoints, palette = theme.palette, shadow = theme.shadow, spacing = theme.spacing;
    return {
        wrenchModal: function (_a) {
            var elevation = _a.elevation;
            return ({
                overflow: 'auto',
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                pointerEvents: 'none',
                zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space,
            });
        },
        wrenchModalContainer: __assign(__assign({}, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .defaultFonts */ .FZ)(theme)), (_a = { boxSizing: 'border-box', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, color: palette.text.dark, background: palette.text.light, zIndex: function (_a) {
                    var elevation = _a.elevation;
                    return (elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space) + 1;
                }, display: 'flex', flexDirection: 'column', overflow: 'auto', whiteSpace: 'normal', outline: 'none', pointerEvents: 'all' }, _a["@media (min-width: ".concat(breakpoints.sm, "px)")] = {
            maxWidth: function (_a) {
                var size = _a.size;
                return ({
                    sm: '80vw',
                    md: '80vw',
                    lg: '80vw',
                    xl: '96vw',
                    full: '100vw',
                }[size]);
            },
            maxHeight: function (_a) {
                var size = _a.size;
                return ({
                    sm: '90vh',
                    md: '90vh',
                    lg: '90vh',
                    xl: '96vh',
                    full: '100vh',
                }[size]);
            },
            borderRadius: function (_a) {
                var fullPage = _a.fullPage;
                return (fullPage ? 0 : spacing[4]);
            },
            boxShadow: shadow.space,
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            height: function (_a) {
                var fullPage = _a.fullPage;
                return (fullPage ? '100%' : 'auto');
            },
            width: function (_a) {
                var size = _a.size;
                return modalWidth[size];
            },
        }, _a)),
        wrenchModalOverlayContainer: function (_a) {
            var elevation = _a.elevation;
            return ({
                zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space,
                position: 'relative',
            });
        },
        wrenchModalOverlay: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: 'fixed',
            backgroundColor: palette.background.overlay,
        },
    };
});

__spreadArray(__spreadArray([], _wds_styles__WEBPACK_IMPORTED_MODULE_3__/* .SIZES.filter */ .zf.filter(function (x) { return x !== 'xs'; }), true), ['full'], false);
var Modal = function (_a) {
    var children = _a.children, closeButtonLabel = _a.closeButtonLabel, dismissible = _a.dismissible, onClose = _a.onClose, show = _a.show, _b = _a.size, size = _b === void 0 ? 'sm' : _b, title = _a.title, elevation = _a.elevation, role = _a.role, rest = __rest(_a, ["children", "closeButtonLabel", "dismissible", "onClose", "show", "size", "title", "elevation", "role"]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
        if (_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU) {
            if (show) {
                document.body.style.overflowY = 'hidden';
            }
            else {
                document.body.style.overflowY = 'auto';
            }
        }
    });
    var modalBodyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.createRef)();
    var prevShow = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .usePreviousState */ .rc)(show);
    var fullPage = size === 'full';
    var _c = useStyles({
        size: size,
        elevation: elevation,
        fullPage: fullPage,
    }), wrenchModal = _c.wrenchModal, wrenchModalContainer = _c.wrenchModalContainer, wrenchModalOverlay = _c.wrenchModalOverlay, wrenchModalOverlayContainer = _c.wrenchModalOverlayContainer;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (modalBodyRef.current && prevShow !== show) {
            modalBodyRef.current.focus({ preventScroll: true });
        }
    }, [modalBodyRef, prevShow, show]);
    var titleId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .uniqueId */ .EL)('modal-title-'); }, []);
    var bodyId = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .uniqueId */ .EL)('modal-body-'); }, []);
    var handleClick = function () {
        if (dismissible) {
            if (onClose) {
                onClose();
            }
        }
    };
    /**
     * ModalHeader exists show aria-labelledby
     * @type {boolean}
     */
    var hasModalHeader = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children).some(function (child) { return react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child) && child.type === ModalHeader; });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: fullPage ? '' : wrenchModalOverlayContainer },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_wds_motion__WEBPACK_IMPORTED_MODULE_1__/* .Fade */ .pT, { in: show },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null,
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_wds_internal_components__WEBPACK_IMPORTED_MODULE_4__/* .Overlay */ .aV, { onClick: handleClick, className: fullPage ? '' : wrenchModalOverlay })))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_wds_motion__WEBPACK_IMPORTED_MODULE_1__/* .Slide */ .Mi, { in: show, direction: "down", distance: "near", speed: "fast" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ className: wrenchModal }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .safeRest */ .Q6)(rest)),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchModalContainer, "aria-label": title, "aria-labelledby": hasModalHeader ? titleId : undefined, "aria-describedby": bodyId, role: role, "aria-modal": "true", tabIndex: -1 },
                        dismissible && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_wds_internal_components__WEBPACK_IMPORTED_MODULE_4__/* .CloseButton */ .PZ, { variant: "dark", onClick: handleClick, label: closeButtonLabel })),
                        react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child) {
                            if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
                                var additionalProps = void 0;
                                if (child.type === ModalHeader) {
                                    additionalProps = {
                                        id: titleId,
                                    };
                                }
                                else if (child.type === ModalBody) {
                                    additionalProps = {
                                        id: bodyId,
                                        handleClick: handleClick,
                                        ref: modalBodyRef,
                                    };
                                }
                                if (additionalProps) {
                                    if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
                                        return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, additionalProps);
                                    }
                                }
                            }
                            return child;
                        })))))));
};
Modal.defaultProps = {
    closeButtonLabel: 'Close Modal',
    dismissible: true,
    onClose: undefined,
    show: false,
    size: 'sm',
    title: undefined,
    elevation: undefined,
    role: 'dialog',
};
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Header = ModalHeader;

var MODAL_SIZES = (/* unused pure expression or super */ null && ([
    'sm',
    'md',
    'lg',
    'xl',
    'full',
]));




/***/ }),

/***/ 4661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pT": function() { return /* binding */ Fade; },
  "Mi": function() { return /* binding */ Slide; }
});

// UNUSED EXPORTS: MOTION_DIRECTIONS, MOTION_DISTANCES, MOTION_SPEEDS, Zoom

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/utils/dist/index.es.js
var index_es = __webpack_require__(5420);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(4578);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js

/* harmony default export */ var TransitionGroupContext = (react.createContext(null));
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js











var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition_CSSTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) forceReflow(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["classNames"]);

    return /*#__PURE__*/react.createElement(esm_Transition, (0,esm_extends/* default */.Z)({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react.Component);

CSSTransition_CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition_CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition_CSSTransition);
// EXTERNAL MODULE: ./node_modules/theming/dist/theming.esm.js
var theming_esm = __webpack_require__(1928);
;// CONCATENATED MODULE: ./node_modules/@wds/motion/dist/index.es.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles$2 = (0,index_es/* createMemoStyles */.Im)({
    wrenchFade: function (_a) {
        var transitionTime = _a.transitionTime;
        return ({
            '&$enter, &$exit': {
                transition: "opacity ".concat(transitionTime, "ms linear"),
            },
        });
    },
    enter: { opacity: '0' },
    enterActive: { opacity: '1' },
    exit: { opacity: '1' },
    exitActive: { opacity: '0' },
});

var Fade = function (_a) {
    var children = _a.children, _b = _a.speed, speed = _b === void 0 ? 'normal' : _b, timeout = _a.timeout, rest = __rest(_a, ["children", "speed", "timeout"]);
    var motion = (0,theming_esm/* useTheme */.Fg)().motion;
    var transitionTime = timeout !== null && timeout !== void 0 ? timeout : motion.fade.speed[speed];
    var _c = useStyles$2({ transitionTime: transitionTime }), wrenchFade = _c.wrenchFade, animationClasses = __rest(_c, ["wrenchFade"]);
    return (react.createElement(esm_CSSTransition, __assign({ className: wrenchFade, classNames: __assign({}, animationClasses), timeout: transitionTime, unmountOnExit: true }, (0,index_es/* safeRest */.Q6)(rest)), children));
};

var speedAnimation = function (isEnter, speed) {
    var curveEntrance = 'cubic-bezier(0, 0, 0, 1)';
    var curveEase = 'cubic-bezier(0.2, 0, 0.1, 1)';
    var bezier = isEnter ? curveEntrance : curveEase;
    var transform = "transform ".concat(speed, "ms ").concat(bezier);
    var opacity = "opacity ".concat(speed / (isEnter ? 5 : 2), "ms linear ").concat(speed / (isEnter ? 10 : 2), "ms");
    return "".concat(transform, ", ").concat(opacity);
};
var directionAnimation = function (direction, distance, isZero) {
    return {
        up: "translateY(".concat(isZero ? 0 : distance, "%)"),
        down: "translateY(-".concat(isZero ? 0 : distance, "%)"),
        left: "translateX(".concat(isZero ? 0 : distance, "%)"),
        right: "translateX(-".concat(isZero ? 0 : distance, "%)"),
    }[direction];
};
var useStyles$1 = (0,index_es/* createMemoStyles */.Im)({
    wrenchSlide: function (_a) {
        var slideSpeed = _a.slideSpeed, direction = _a.direction, slideDistance = _a.slideDistance;
        return ({
            '&$enter': {
                transform: directionAnimation(direction, slideDistance, false),
            },
            '&$enterActive': {
                transition: speedAnimation(true, slideSpeed),
                transform: directionAnimation(direction, slideDistance, true),
            },
            '&$exit': {
                transform: directionAnimation(direction, slideDistance, true),
            },
            '&$exitActive': {
                transition: speedAnimation(false, slideSpeed),
                transform: directionAnimation(direction, slideDistance, false),
            },
        });
    },
    enter: { opacity: '0' },
    enterActive: { opacity: '1' },
    exit: { opacity: '1' },
    exitActive: { opacity: '0' },
});

var Slide = function (_a) {
    var children = _a.children, timeout = _a.timeout, _b = _a.direction, direction = _b === void 0 ? 'up' : _b, _c = _a.speed, speed = _c === void 0 ? 'normal' : _c, _d = _a.distance, distance = _d === void 0 ? 'normal' : _d, rest = __rest(_a, ["children", "timeout", "direction", "speed", "distance"]);
    var motion = (0,theming_esm/* useTheme */.Fg)().motion;
    var slideSpeed = timeout !== null && timeout !== void 0 ? timeout : motion.slide.speed[speed];
    var slideDistance = motion.slide.distance[distance];
    var _e = useStyles$1({
        slideSpeed: slideSpeed,
        direction: direction,
        slideDistance: slideDistance,
    }), wrenchSlide = _e.wrenchSlide, animationClasses = __rest(_e, ["wrenchSlide"]);
    return (react.createElement(esm_CSSTransition, __assign({ className: wrenchSlide, classNames: __assign({}, animationClasses), timeout: slideSpeed, unmountOnExit: true }, (0,index_es/* safeRest */.Q6)(rest)), children));
};

var bezier = 'cubic-bezier(0, 0, 0, 1)';
var useStyles = (0,index_es/* createMemoStyles */.Im)({
    wrenchZoom: function (_a) {
        var timeout = _a.timeout;
        return ({
            '&$enterActive': {
                transition: "transform ".concat(timeout, "ms ").concat(bezier, ", opacity 100ms linear"),
            },
            '&$exitActive': {
                transition: "transform ".concat(timeout, "ms ").concat(bezier, ", opacity 50ms linear 50ms"),
            },
        });
    },
    enter: { opacity: '0', transform: 'scale(0.8)' },
    enterActive: { opacity: '1', transform: 'scale(1)' },
    exit: { opacity: '1', transform: 'scale(1)' },
    exitActive: { opacity: '0', transform: 'scale(0.8)' },
});

var Zoom = function (_a) {
    var children = _a.children, _b = _a.timeout, timeout = _b === void 0 ? 250 : _b, rest = __rest(_a, ["children", "timeout"]);
    var _c = useStyles({ timeout: timeout }), wrenchZoom = _c.wrenchZoom, animationClasses = __rest(_c, ["wrenchZoom"]);
    return (React.createElement(CSSTransition, __assign({ className: wrenchZoom, classNames: __assign({}, animationClasses), timeout: timeout, unmountOnExit: true }, safeRest(rest)), children));
};

var MOTION_SPEEDS = (/* unused pure expression or super */ null && (['slow', 'normal', 'fast']));
var MOTION_DIRECTIONS = (/* unused pure expression or super */ null && (['up', 'right', 'down', 'left']));
var MOTION_DISTANCES = (/* unused pure expression or super */ null && (['normal', 'near', 'far']));




/***/ }),

/***/ 6808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 5849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* reexport */ FiveHundredError_FiveHundredError; },
  "v": function() { return /* reexport */ FiveHundredErrorPage; }
});

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/index.js + 4 modules
var ClientError = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/Links/index.js + 1 modules
var Links = __webpack_require__(6667);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FiveHundredError/FiveHundredError.js
var _excluded = [
    "openingMessage",
    "errorTitle",
    "titularElementTag",
    "errorMessage",
    "linksProps",
    "data-testid"
];
var _jsxFileName = "/repo/packages/webassets/src/components/FiveHundredError/FiveHundredError.tsx", _this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    SORRY_MESSAGE: {
        id: "FiveHundredError.SorryMessage",
        defaultMessage: "We're sorry",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    SOMETHING_WRONG: {
        id: "FiveHundredError.SomethingWentWrong",
        defaultMessage: "Something went wrong.",
        description: "[Type: Label][Vis.: med] - something went wrong subtitle"
    },
    FIVE_HUNDRED_MESSAGE: {
        id: "FiveHundredError.Message",
        defaultMessage: "Sorry if you lost your place - we're working hard to get things up and running again. Thanks for your patience!",
        description: "[Type: Label][Vis.: med] - Five Hundred Error Message"
    }
});
var FiveHundredError = function FiveHundredError(_ref) {
    var _ref$openingMessage = _ref.openingMessage, openingMessage = _ref$openingMessage === void 0 ? (0,dist.t)(DEFAULT_COPY.SORRY_MESSAGE) : _ref$openingMessage, _ref$errorTitle = _ref.errorTitle, errorTitle = _ref$errorTitle === void 0 ? (0,dist.t)(DEFAULT_COPY.SOMETHING_WRONG) : _ref$errorTitle, _ref$titularElementTa = _ref.titularElementTag, titularElementTag = _ref$titularElementTa === void 0 ? "p" : _ref$titularElementTa, _ref$errorMessage = _ref.errorMessage, errorMessage = _ref$errorMessage === void 0 ? (0,dist.t)(DEFAULT_COPY.FIVE_HUNDRED_MESSAGE) : _ref$errorMessage, linksProps = _ref.linksProps, _ref$dataTestid = _ref["data-testid"], dataTestId = _ref$dataTestid === void 0 ? "FiveHundredError" : _ref$dataTestid, props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ react.createElement(ClientError/* ClientError */.XF, Object.assign({
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        "data-testid": dataTestId
    }, props, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 44,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Box */.x, {
        mt: 4,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 7
        }
    }, react.Children.map(errorMessage, function(message) {
        return /*#__PURE__*/ react.createElement("p", {
            "data-testid": "".concat(dataTestId, "_ErrorMessage"),
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 53,
                columnNumber: 18
            }
        }, message);
    })), /*#__PURE__*/ react.createElement(Links/* default */.Z, Object.assign({}, linksProps, {
        mt: 6,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 56,
            columnNumber: 7
        }
    })));
};
/* harmony default export */ var FiveHundredError_FiveHundredError = ((0,theme/* withWebAssetsTheme */.I6)(FiveHundredError)); //# sourceMappingURL=FiveHundredError.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FiveHundredError/FiveHundredErrorPage.js



/* harmony default export */ var FiveHundredErrorPage = ((0,theme/* withWebAssetsTheme */.I6)((0,ClientError/* withClientErrorPage */.Fs)(FiveHundredError_FiveHundredError, {
    titularElementTag: "h1",
    // set default to H1
    errorCode: 500
}))); //# sourceMappingURL=FiveHundredErrorPage.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FiveHundredError/index.js

 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ForbiddenError_ForbiddenError; }
});

// UNUSED EXPORTS: ForbiddenErrorPage

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/index.js + 4 modules
var ClientError = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/Links/index.js + 1 modules
var Links = __webpack_require__(6667);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ForbiddenError/ForbiddenError.js
var _excluded = [
    "openingMessage",
    "errorTitle",
    "titularElementTag",
    "errorMessage",
    "linksProps",
    "showLinks",
    "data-testid"
];
var _jsxFileName = "/repo/packages/webassets/src/components/ForbiddenError/ForbiddenError.tsx", _this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






// put this into common error component strings file
var DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    SORRY_MESSAGE: {
        id: "ForbiddenError.sorryMessage",
        defaultMessage: "We're sorry",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    PERMISSIONS: {
        id: "ForbiddenError.permissions",
        defaultMessage: "You do not have permission to see this page.",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    CHECK_URL: {
        id: "ForbiddenError.checkURL",
        defaultMessage: "Please check the URL you entered to make sure it's spelled correctly.",
        description: "[Type: Label][Vis.: med] - check URL subtitle"
    },
    HELP_FIND_WAY: {
        id: "ForbiddenError.helpFindWay",
        defaultMessage: "Still not sure how to get to the page you want? Maybe we can help you find your way:",
        description: "[Type: Label][Vis.: med] - Help find your way subtitle"
    }
});
var ForbiddenError = function ForbiddenError(_ref) {
    var _ref$openingMessage = _ref.openingMessage, openingMessage = _ref$openingMessage === void 0 ? (0,dist.t)(DEFAULT_COPY.SORRY_MESSAGE) : _ref$openingMessage, _ref$errorTitle = _ref.errorTitle, errorTitle = _ref$errorTitle === void 0 ? (0,dist.t)(DEFAULT_COPY.PERMISSIONS) : _ref$errorTitle, _ref$titularElementTa = _ref.titularElementTag, titularElementTag = _ref$titularElementTa === void 0 ? "p" : _ref$titularElementTa, _ref$errorMessage = _ref.errorMessage, errorMessage = _ref$errorMessage === void 0 ? [
        (0,dist.t)(DEFAULT_COPY.CHECK_URL),
        (0,dist.t)(DEFAULT_COPY.HELP_FIND_WAY)
    ] : _ref$errorMessage, linksProps = _ref.linksProps, _ref$showLinks = _ref.showLinks, showLinks = _ref$showLinks === void 0 ? true : _ref$showLinks, _ref$dataTestid = _ref["data-testid"], dataTestId = _ref$dataTestid === void 0 ? "ForbiddenError" : _ref$dataTestid, props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ react.createElement(ClientError/* ClientError */.XF, Object.assign({
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        "data-testid": dataTestId
    }, props, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 53,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Box */.x, {
        mt: 4,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 60,
            columnNumber: 7
        }
    }, react.Children.map(errorMessage, function(message) {
        return /*#__PURE__*/ react.createElement("p", {
            "data-testid": "".concat(dataTestId, "_ErrorMessage"),
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 62,
                columnNumber: 18
            }
        }, message);
    })), showLinks && /*#__PURE__*/ react.createElement(Links/* default */.Z, Object.assign({}, linksProps, {
        mt: 6,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 65,
            columnNumber: 21
        }
    })));
};
/* harmony default export */ var ForbiddenError_ForbiddenError = ((0,theme/* withWebAssetsTheme */.I6)(ForbiddenError)); //# sourceMappingURL=ForbiddenError.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ForbiddenError/ForbiddenErrorPage.js



/* harmony default export */ var ForbiddenErrorPage = ((0,theme/* withWebAssetsTheme */.I6)((0,ClientError/* withClientErrorPage */.Fs)(ForbiddenError_ForbiddenError, {
    titularElementTag: "h1",
    // set default to H1
    errorCode: 403
}))); //# sourceMappingURL=ForbiddenErrorPage.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ForbiddenError/index.js

 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 2512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ FourHundredError_FourHundredError; }
});

// UNUSED EXPORTS: FourHundredErrorPage

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/index.js + 4 modules
var ClientError = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/SignupButton/index.js + 1 modules
var SignupButton = __webpack_require__(3613);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/Links/index.js + 1 modules
var Links = __webpack_require__(6667);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourHundredError/FourHundredError.js
var _excluded = [
    "openingMessage",
    "errorTitle",
    "titularElementTag",
    "errorMessage",
    "signupButtonProps",
    "linksProps",
    "showLinks",
    "data-testid"
];
var _jsxFileName = "/repo/packages/webassets/src/components/FourHundredError/FourHundredError.tsx", _this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var COPY = (0,dist/* defineMessages */.vU)({
    SORRY_MESSAGE: {
        id: "FourHundredError.sorryMessage",
        defaultMessage: "We're sorry",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    CANT_FIND_PAGE: {
        id: "FourHundredError.cantFindPage",
        defaultMessage: "We can't find the page you're looking for.",
        description: "[Type: Label][Vis.: med] - Cant find page message"
    },
    CHECK_URL: {
        id: "FourHundredError.checkURL",
        defaultMessage: "Please check the URL you entered to make sure it's spelled correctly.",
        description: "[Type: Label][Vis.: med] - check URL subtitle"
    },
    HELP_FIND_WAY: {
        id: "FourHundredError.helpFindWay",
        defaultMessage: "Still not sure how to get to the page you want? Maybe we can help you find your way:",
        description: "[Type: Label][Vis.: med] - Help find your way subtitle"
    }
});
var FourHundredError = function FourHundredError(_ref) {
    var _ref$openingMessage = _ref.openingMessage, openingMessage = _ref$openingMessage === void 0 ? (0,dist.t)(COPY.SORRY_MESSAGE) : _ref$openingMessage, _ref$errorTitle = _ref.errorTitle, errorTitle = _ref$errorTitle === void 0 ? (0,dist.t)(COPY.CANT_FIND_PAGE) : _ref$errorTitle, _ref$titularElementTa = _ref.titularElementTag, titularElementTag = _ref$titularElementTa === void 0 ? "p" : _ref$titularElementTa, _ref$errorMessage = _ref.errorMessage, errorMessage = _ref$errorMessage === void 0 ? [
        (0,dist.t)(COPY.CHECK_URL),
        (0,dist.t)(COPY.HELP_FIND_WAY)
    ] : _ref$errorMessage, signupButtonProps = _ref.signupButtonProps, linksProps = _ref.linksProps, _ref$showLinks = _ref.showLinks, showLinks = _ref$showLinks === void 0 ? false : _ref$showLinks, _ref$dataTestid = _ref["data-testid"], dataTestId = _ref$dataTestid === void 0 ? "FourHundredError" : _ref$dataTestid, props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ react.createElement(ClientError/* ClientError */.XF, Object.assign({
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        "data-testid": dataTestId
    }, props, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 53,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Box */.x, {
        mt: 4,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 60,
            columnNumber: 7
        }
    }, react.Children.map(errorMessage, function(message) {
        return /*#__PURE__*/ react.createElement("p", {
            "data-testid": "".concat(dataTestId, "_ErrorMessage"),
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 62,
                columnNumber: 11
            }
        }, message);
    })), /*#__PURE__*/ react.createElement(SignupButton/* default */.Z, Object.assign({}, signupButtonProps, {
        mt: 5,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 65,
            columnNumber: 7
        }
    })), showLinks && /*#__PURE__*/ react.createElement(Links/* default */.Z, Object.assign({}, linksProps, {
        mt: 6,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 66,
            columnNumber: 21
        }
    })));
};
/* harmony default export */ var FourHundredError_FourHundredError = ((0,theme/* withWebAssetsTheme */.I6)(FourHundredError)); //# sourceMappingURL=FourHundredError.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourHundredError/FourHundredErrorPage.js



/* harmony default export */ var FourHundredErrorPage = ((0,theme/* withWebAssetsTheme */.I6)((0,ClientError/* withClientErrorPage */.Fs)(FourHundredError_FourHundredError, {
    titularElementTag: "h1",
    // set default to H1
    errorCode: 400
}))); //# sourceMappingURL=FourHundredErrorPage.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourHundredError/index.js

 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ FourOhFourError_FourOhFourError; },
  "d": function() { return /* reexport */ FourOhFourErrorPage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/index.js + 4 modules
var ClientError = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/SignupButton/index.js + 1 modules
var SignupButton = __webpack_require__(3613);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/Links/index.js + 1 modules
var Links = __webpack_require__(6667);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourOhFourError/FourOhFourError.js
var _excluded = [
    "openingMessage",
    "errorTitle",
    "titularElementTag",
    "errorMessage",
    "signupButtonProps",
    "linksProps",
    "showLinks",
    "data-testid"
];
var _jsxFileName = "/repo/packages/webassets/src/components/FourOhFourError/FourOhFourError.tsx", _this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var COPY = (0,dist/* defineMessages */.vU)({
    SORRY_MESSAGE: {
        id: "FourOhFourError.sorryMessage",
        defaultMessage: "We're sorry",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    CANT_FIND_PAGE: {
        id: "FourOhFourError.cantFindPage",
        defaultMessage: "We can't find the page you're looking for.",
        description: "[Type: Label][Vis.: med] - Cant find page message"
    },
    CHECK_URL: {
        id: "FourOhFourError.checkURL",
        defaultMessage: "Please check the URL you entered to make sure it's spelled correctly.",
        description: "[Type: Label][Vis.: med] - check URL subtitle"
    },
    HELP_FIND_WAY: {
        id: "FourOhFourError.helpFindWay",
        defaultMessage: "Still not sure how to get to the page you want? Maybe we can help you find your way:",
        description: "[Type: Label][Vis.: med] - Help find your way subtitle"
    }
});
var FourOhFourError = function FourOhFourError(_ref) {
    var _ref$openingMessage = _ref.openingMessage, openingMessage = _ref$openingMessage === void 0 ? (0,dist.t)(COPY.SORRY_MESSAGE) : _ref$openingMessage, _ref$errorTitle = _ref.errorTitle, errorTitle = _ref$errorTitle === void 0 ? (0,dist.t)(COPY.CANT_FIND_PAGE) : _ref$errorTitle, _ref$titularElementTa = _ref.titularElementTag, titularElementTag = _ref$titularElementTa === void 0 ? "p" : _ref$titularElementTa, _ref$errorMessage = _ref.errorMessage, errorMessage = _ref$errorMessage === void 0 ? [
        (0,dist.t)(COPY.CHECK_URL),
        (0,dist.t)(COPY.HELP_FIND_WAY)
    ] : _ref$errorMessage, signupButtonProps = _ref.signupButtonProps, linksProps = _ref.linksProps, _ref$showLinks = _ref.showLinks, showLinks = _ref$showLinks === void 0 ? false : _ref$showLinks, _ref$dataTestid = _ref["data-testid"], dataTestId = _ref$dataTestid === void 0 ? "FourOhFourError" : _ref$dataTestid, props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ react.createElement(ClientError/* ClientError */.XF, Object.assign({
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        "data-testid": dataTestId
    }, props, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 53,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Box */.x, {
        mt: 4,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 60,
            columnNumber: 7
        }
    }, react.Children.map(errorMessage, function(message) {
        return /*#__PURE__*/ react.createElement("p", {
            "data-testid": "".concat(dataTestId, "_ErrorMessage"),
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 62,
                columnNumber: 18
            }
        }, message);
    })), /*#__PURE__*/ react.createElement(SignupButton/* default */.Z, Object.assign({}, signupButtonProps, {
        mt: 5,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 65,
            columnNumber: 7
        }
    })), showLinks && /*#__PURE__*/ react.createElement(Links/* default */.Z, Object.assign({}, linksProps, {
        mt: 6,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 66,
            columnNumber: 21
        }
    })));
};
/* harmony default export */ var FourOhFourError_FourOhFourError = ((0,theme/* withWebAssetsTheme */.I6)(FourOhFourError)); //# sourceMappingURL=FourOhFourError.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourOhFourError/FourOhFourErrorPage.js



/* A variant when showing 404 error as a page */ /* harmony default export */ var FourOhFourErrorPage = ((0,theme/* withWebAssetsTheme */.I6)((0,ClientError/* withClientErrorPage */.Fs)(FourOhFourError_FourOhFourError, {
    titularElementTag: "h1",
    // set default to H1
    showLinks: true,
    errorCode: 404
}))); //# sourceMappingURL=FourOhFourErrorPage.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourOhFourError/index.js

 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 7111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* reexport */ FourTenError_FourTenError; }
});

// UNUSED EXPORTS: FourTenErrorPage

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/index.js + 4 modules
var ClientError = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/Links/index.js + 1 modules
var Links = __webpack_require__(6667);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/SignupButton/index.js + 1 modules
var SignupButton = __webpack_require__(3613);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourTenError/FourTenError.js
var _excluded = [
    "openingMessage",
    "errorTitle",
    "titularElementTag",
    "signupButtonProps",
    "primaryLinksProps",
    "secondaryLinksProps",
    "data-testid"
];
var _jsxFileName = "/repo/packages/webassets/src/components/FourTenError/FourTenError.tsx", _this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    // Client Error
    OH_BANANAS: {
        id: "FourTenError.ohBananas",
        defaultMessage: "Oh bananas!",
        description: "[Type: Label][Vis.: med] - Oh bananas message"
    },
    TERMS_VIOLATION: {
        id: "FourTenError.somethingWentWrong",
        defaultMessage: "This survey is currently closed due to a violation of SurveyMonkey's terms of use.",
        description: "[Type: Label][Vis.: med] - terms of use violation title"
    },
    // Primary Links
    HOME: {
        id: "FourTenError.home",
        defaultMessage: "SurveyMonkey Home",
        description: "[Type: Label][Vis.: med] - Home link in 410 Error Message"
    },
    SITEMAP: {
        id: "FourTenError.sitemap",
        defaultMessage: "Sitemap",
        description: "[Type: Label][Vis.: med] - Sitemap link in 410 Error Message"
    },
    LEARN_MORE: {
        id: "FourTenError.howItWorks",
        defaultMessage: "How It Works",
        description: "[Type: Label][Vis.: med] - How It Works link in 410 Error Message"
    },
    // Secondary Links
    TYPES: {
        id: "FourTenError.types",
        defaultMessage: "Survey Types",
        description: "[Type: Label][Vis.: med] - Survey Types link in 410 Error Message"
    },
    SATISFACTION_SURVEYS: {
        id: "FourTenError.satisfactionSurveys",
        defaultMessage: "Customer Satisfaction Surveys",
        description: "[Type: Label][Vis.: med] - Customer Satisfaction Surveys link in 410 Error Message"
    },
    EMPLOYEE_SURVEYS: {
        id: "FourTenError.employeeSurveys",
        defaultMessage: "Employee Surveys",
        description: "[Type: Label][Vis.: med] - Employee Surveys link in 410 Error Message"
    }
});
var defaultPrimaryLinks = {
    links: [
        {
            label: (0,dist.t)(DEFAULT_COPY.HOME),
            href: "/"
        },
        {
            label: (0,dist.t)(DEFAULT_COPY.SITEMAP),
            href: "/mp/sitemap/"
        },
        {
            label: (0,dist.t)(DEFAULT_COPY.LEARN_MORE),
            href: "/mp/take-a-tour/"
        }
    ]
};
var defaultSecondaryLinks = {
    links: [
        {
            label: (0,dist.t)(DEFAULT_COPY.TYPES),
            href: "/mp/survey-types/"
        },
        {
            label: (0,dist.t)(DEFAULT_COPY.SATISFACTION_SURVEYS),
            href: "/mp/customer-satisfaction-surveys/"
        },
        {
            label: (0,dist.t)(DEFAULT_COPY.EMPLOYEE_SURVEYS),
            href: "/mp/employee-surveys/"
        }
    ]
};
var FourTenError = function FourTenError(_ref) {
    var _ref$openingMessage = _ref.openingMessage, openingMessage = _ref$openingMessage === void 0 ? (0,dist.t)(DEFAULT_COPY.OH_BANANAS) : _ref$openingMessage, _ref$errorTitle = _ref.errorTitle, errorTitle = _ref$errorTitle === void 0 ? (0,dist.t)(DEFAULT_COPY.TERMS_VIOLATION) : _ref$errorTitle, _ref$titularElementTa = _ref.titularElementTag, titularElementTag = _ref$titularElementTa === void 0 ? "p" : _ref$titularElementTa, signupButtonProps = _ref.signupButtonProps, _ref$primaryLinksProp = _ref.primaryLinksProps, primaryLinksProps = _ref$primaryLinksProp === void 0 ? defaultPrimaryLinks : _ref$primaryLinksProp, _ref$secondaryLinksPr = _ref.secondaryLinksProps, secondaryLinksProps = _ref$secondaryLinksPr === void 0 ? defaultSecondaryLinks : _ref$secondaryLinksPr, _ref$dataTestid = _ref["data-testid"], dataTestId = _ref$dataTestid === void 0 ? "FourTenError" : _ref$dataTestid, props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ react.createElement(ClientError/* ClientError */.XF, Object.assign({
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        "data-testid": dataTestId
    }, props, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 112,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(SignupButton/* default */.Z, Object.assign({}, signupButtonProps, {
        mt: 5,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 119,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Links/* default */.Z, Object.assign({}, primaryLinksProps, {
        mt: 6,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 120,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Links/* default */.Z, Object.assign({}, secondaryLinksProps, {
        mt: 6,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 121,
            columnNumber: 7
        }
    })));
};
/* harmony default export */ var FourTenError_FourTenError = ((0,theme/* withWebAssetsTheme */.I6)(FourTenError)); //# sourceMappingURL=FourTenError.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourTenError/FourTenErrorPage.js



/* harmony default export */ var FourTenErrorPage = ((0,theme/* withWebAssetsTheme */.I6)((0,ClientError/* withClientErrorPage */.Fs)(FourTenError_FourTenError, {
    titularElementTag: "h1",
    // set default to H1
    errorCode: 410
}))); //# sourceMappingURL=FourTenErrorPage.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/FourTenError/index.js

 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ })

}]);